import { render, staticRenderFns } from "./TrustpilotRating.vue?vue&type=template&id=67ffadb5&scoped=true&"
import script from "./TrustpilotRating.vue?vue&type=script&lang=ts&"
export * from "./TrustpilotRating.vue?vue&type=script&lang=ts&"
import style0 from "./TrustpilotRating.vue?vue&type=style&index=0&id=67ffadb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ffadb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('67ffadb5', component.options)
    } else {
      api.reload('67ffadb5', component.options)
    }
    module.hot.accept("./TrustpilotRating.vue?vue&type=template&id=67ffadb5&scoped=true&", function () {
      api.rerender('67ffadb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/landing/TrustpilotRating.vue"
export default component.exports